'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (props, position) {
  var min = props.min,
      max = props.max,
      trackOffset = props.trackOffset,
      step = props.step,
      orientation = props.orientation;
  var ratio = (max - min) / trackOffset[_constants2["default"][orientation].dimension];
  if ((0, _utils.isVertical)(orientation)) position = trackOffset.height - position;
  return (0, _utils.formatNumber)(position * ratio, step, min);
};

var _utils = require('../utils');

var _constants = require('../constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}